import { UploadOutlined } from "@mui/icons-material";
import { API } from "../../config/api";
import { GET, PUT } from "../../utils/apicalls";
import { Button, Card, Form, Input, notification, Upload } from "antd";
import AWS from "aws-sdk";
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";


function UpdateAboutUsManagement() {
  interface AwsData {
    accessKeyId?: string;
    secretAccessKey?: string;
    region?: string;
    [key: string]: any;
  }
  const [awsData, setawsData] = useState<AwsData>({});
  const [form] = Form.useForm();
  const [data, setData] = useState<any>([]);
  const [isLoading, setIsLoading] = useState(false);
  const [fileUrl, setFileUrl] = useState<string | null>(null);
  const s3 = new AWS.S3({
    accessKeyId: awsData.accessKeyId,
    secretAccessKey: awsData.secretAccessKey,
    region: awsData.region,
  });
  const navigate = useNavigate();
  const { id } = useParams();

  const handleFileChange = (info: any) => {
    if (info.file.status === "done") {
      const fileUrl = info.file.response?.location || info.file.response?.url; // AWS usually returns `location`
      if (fileUrl) {
        setFileUrl(fileUrl);
        form.setFieldsValue({ serviceCategory: fileUrl }); // Update form field value
      }
    } else if (info.file.status === "error") {
      notification.error({ message: "File upload failed!" });
    }
  };

  const fetchawsDetails = async () => {
    try {
      setIsLoading(true);
      const response: any = await GET(API.AWS_KEY, {}); // This should return the above JSON
      if (response && response.accessKeyId) {
        setawsData(response); // Not response.data
      } else if (response?.data?.accessKeyId) {
        setawsData(response.data); // If using Axios-style
      } else {
        console.warn("AWS credentials not found in response", response);
      }
    } catch (error) {
      console.error("Failed to fetch AWS credentials", error);
    } finally {
      setIsLoading(false);
    }
  };
  useEffect(() => {
    if (awsData.accessKeyId && awsData.secretAccessKey && awsData.region) {
      AWS.config.update({
        accessKeyId: awsData.accessKeyId,
        secretAccessKey: awsData.secretAccessKey,
        region: awsData.region,
      });
    }
  }, [awsData]);
  useEffect(() => {
    fetchawsDetails();
  }, []);
  const S3_BUCKET = awsData?.bucketName;

  const uploadProps = {
    name: "file",
    action: `https://s3.${AWS.config.region}.amazonaws.com/${S3_BUCKET}/`,
    headers: {
      "x-amz-acl": "public-read",
      "Content-Type": "multipart/form-data",
    },
    onChange: handleFileChange,
    customRequest: async (options: any) => {
      const { onSuccess, onError, file } = options;
      const params = {
        Bucket: S3_BUCKET,
        Key: `about/${file.name}`,
        Body: file,
        // ACL: "public-read",
        ContentType: file.type,
      };

      s3.upload(params, (err: any, data: any) => {
        if (err) {
          onError(err);
          notification.error({ message: "File upload failed!" });
        } else {
          setFileUrl(data.Location); // Set file URL on successful upload
          form.setFieldsValue({ serviceCategory: data.Location });
          onSuccess(data);
          notification.success({ message: "File uploaded successfully!" });
        }
      });
    },
  };

  const UpdateHandler = async (values: any) => {
    try {
      let obj = {
        aboutTitle: values.aboutTitle,
        aboutSubtitle: values.aboutSubtitle,
        aboutDescription: values.aboutDescription,
        aboutImage: fileUrl || values.aboutImage,
      };

      setIsLoading(true);
      let api = API.UPDATE_ABOUTUS + id;
      const postRequest: any = await PUT(api, obj);
      if (postRequest.status) {
        notification.success({ message: "about updated successfully!" });
        form.resetFields();
        fetchOneBanners();
        navigate(-1);
      } else {
        notification.error({ message: "Something went wrong" });
      }
    } catch (error) {
      console.error(error);
      notification.error({
        message: "Something went wrong! Please try again later",
      });
    } finally {
      setIsLoading(false);
    }
  };

  const fetchOneBanners = async () => {
    try {
      setIsLoading(true);
      let api = API.GET_ONE_ABOUTUS + id;
      const response: any = await GET(api, {});
      setData(response?.data);
      form.setFieldsValue(response?.data);
      if (response?.data?.aboutImage) {
        setFileUrl(response.data.aboutImage);
      }
    } catch (error) {
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  };
  useEffect(() => {
    fetchOneBanners();
  }, []);

  return (
    <div>
      <h1>Update About page</h1>
      <Card>
        <Form form={form} onFinish={UpdateHandler} layout="vertical">
          <Form.Item
            name="aboutTitle"
            label="aboutTitle"
            rules={[{ required: true }]}
          >
            <Input />
          </Form.Item>
          <Form.Item
            name="aboutSubtitle"
            label="aboutSubtitle"
            rules={[{ required: true, message: "aboutSubtitle is required" }]}
          >
            <Input />
          </Form.Item>
          <Form.Item
            name="aboutDescription"
            label="aboutDescription"
            rules={[{ required: true }]}
          >
            <Input />
          </Form.Item>
          <Form.Item label="Banner Image" name="aboutImage">
            <Upload {...uploadProps}>
              <Button icon={<UploadOutlined />}>Upload Image</Button>
            </Upload>
          </Form.Item>

          {/* Display Uploaded Image */}
          {fileUrl && (
            <div style={{ marginTop: 10 }}>
              <img
                src={fileUrl}
                alt="Uploaded Banner"
                style={{ width: "100%", maxHeight: 200, objectFit: "cover" }}
              />
            </div>
          )}

          <Button type="primary" htmlType="submit" block>
            Submit
          </Button>
        </Form>
      </Card>
    </div>
  );
}

export default UpdateAboutUsManagement;
